export default "__VITE_ASSET__DD2dNLc5__"